export default __webpack_public_path__ + "static/media/settings.0710f3d9.svg";